import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { initializeTheme } from './components/common/ThemeToggle';
import App from './App';

// Apply stored theme (light/dark) before first render to avoid flash
initializeTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
